// extracted by mini-css-extract-plugin
module.exports = {"PostsList":"PostsList_PostsList__9B2bc","grid":"PostsList_grid__jtMTr","thumbnails":"PostsList_thumbnails__ayCyX"};